<template>
  <div class="user-management" dir="rtl">
    <div class="container">
      <!-- Header Section -->
      <header class="header">
        <h1 class="page-title">المعاملات</h1>
        <p class="page-subtitle">تقرير عن معاملات السحب والإيداع</p>
      </header>

      <!-- Users Table -->
      <div class="table-container">
        <!-- Table Search and Filters -->
        <div class="table-header">
          <h2 class="table-title">قائمة المعاملات</h2>
          <div class="table-actions">
            <div class="search-container">
              <input
                type="text"
                v-model="searchQuery"
                placeholder="بحث..."
                class="search-input"
              />
              <span class="search-icon" @click="search()">🔍</span>
            </div>
          </div>
        </div>

        <!-- Users Table -->
        <div class="table-responsive">
          <table class="users-table table table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>التسلسل</th>
                <th>اسم الزبون</th>
                <th>رقم الطلب</th>
                <th>الحالة</th>
                <th>المبلغ</th>
                <th>الوصف</th>
                <th>التاريخ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(transaction, index) in list" :key="transaction.id">
                <td>{{ (pageNumber - 1) * pageSize + (index + 1) }}</td>
                <td>{{ transaction.user.fullName }}</td>
                <td>{{ transaction.orderId }}</td>
                <td :class="{'text-success': transaction.isComplete, 'text-danger': !transaction.isComplete}">
                  {{ transaction.isComplete ? 'مكتمل' : 'قيد التنفيذ' }}
                </td>
                <td>{{ transaction.amount }} نقطة</td>
                <td>{{ transaction.description || 'لا يوجد وصف' }}</td>
                <td>{{ formatDate(transaction.createdAt) }}</td>
              </tr>

              <!-- Empty State -->
              <tr v-if="list.length === 0">
                <td colspan="7" class="empty-state">
                  <div class="empty-icon">👥</div>
                  <h3>لا توجد معاملات</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="pagination-container">
          <custom-pagination
            :currentPage="pageNumber"
            :totalPages="totalPages"
            @page-changed="handlePageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import Swal from "sweetalert2";

export default {
  name: "UserManagement",
  components: { CustomPagination },
  data() {
    return {
      list: [],
      pageNumber: 1,
      pageSize: 8,
      totalPages: 1,
      searchQuery : "",
    };
  },
  methods: {

    search() {
      this.pageNumber = 1;
      this.getAllTransctions();
    },
    async getAllTransctions() {
      try {
        const response = await apiClient.get("/api/Transaction/GetTransactions", {
          params: { PageNumber: this.pageNumber, PageSize: this.pageSize , SearchQuery: this.searchQuery },
        });
        this.list = response.data.items;
        this.pageNumber = response.data.pageNumber;
        this.totalPages = response.data.totalPages;
      } catch (error) {
        console.error("حدث خطأ أثناء جلب البيانات ", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب البيانات",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
   // formatDate
    formatDate(date) {
      return new Date(date).toLocaleDateString("ar-EG", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    // handlePageChange
    handlePageChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.getAllTransctions();
    },
    
  },

  mounted() {
    this.getAllTransctions();
  },
};
</script>

<style scoped>
.btn-action {
  margin: 3px;
}
.user-management {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 3rem;
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  animation: slideDown 0.5s ease-out;
}

.table-responsive {
  overflow-x: auto;
  white-space: nowrap;
}

.page-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.btn-add {
  background: #4299e1;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-add:hover {
  background: #3182ce;
  transform: translateY(-1px);
}

/* Table Styles */
.table-container {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.table-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
}

.users-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.users-table th {
  background: #f7fafc;
  padding: 1rem;
  font-weight: 600;
  color: #4a5568;
  text-align: right;
  border-bottom: 2px solid #e2e8f0;
}

.users-table td {
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s;
}

.users-table tr:hover td {
  background-color: #f7fafc;
}

/* Button Styles */
.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.btn-edit {
  background: #faf089;
  color: #744210;
}

.btn-edit:hover {
  background: #f6e05e;
}

.btn-delete {
  background: #fed7d7;
  color: #c53030;
}

.btn-delete:hover {
  background: #feb2b2;
}

.btn-point {
  background: #c6f6d5;
  color: #276749;
}

.btn-point:hover {
  background: #9ae6b4;
}

/* Modal Styles */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 1rem;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

/* Form Styles */
.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  outline: none;
}

/* Row Layout */
.row {
  display: flex;
  flex-wrap: wrap;
  margin: -0.5rem;
}

.col-4 {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
  padding: 0.5rem;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0.5rem;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0.5rem;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.btn-primary {
  background: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
}

.btn-primary:hover {
  background: #3182ce;
}

.btn-secondary {
  background: #e2e8f0;
  color: #4a5568;
  padding: 0.75rem 1.5rem;
}

.btn-secondary:hover {
  background: #cbd5e0;
}

/* Points Modal */
.points-modal .modal-content {
  max-width: 400px;
}

/* Animations */
@keyframes modalSlideIn {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .user-management {
    padding: 1rem;
  }

  .header {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .col-4,
  .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  .table-container {
    overflow-x: auto;
  }

  .users-table {
    white-space: nowrap;
  }
}

/* RTL Support */
[dir="rtl"] .modal-close {
  left: 1rem;
  right: auto;
}

[dir="rtl"] .form-control {
  text-align: right;
}

[dir="rtl"] .modal-actions {
  flex-direction: row-reverse;
}

.modal-body {
  padding: 1.5rem;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

/* Form Styles */
.user-form {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  margin: 0 -0.75rem;
  margin-bottom: 1.5rem;
}

.form-group {
  padding: 0 0.75rem;
}

.col-4 {
  width: 33.333333%;
}

.col-6 {
  width: 50%;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  outline: none;
}

/* Password Input */
.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #718096;
  cursor: pointer;
  padding: 0.25rem;
}

.toggle-password:hover {
  color: #4a5568;
}

/* Buttons */
.btn-submit {
  background: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-submit:hover:not(:disabled) {
  background: #3182ce;
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-cancel {
  background: #e2e8f0;
  color: #4a5568;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #cbd5e0;
}

/* Loading Spinner */
.spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid #ffffff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Modal Animation */
@keyframes modalSlideIn {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* RTL Specific */
[dir="rtl"] .modal-close {
  left: 1.5rem;
  right: auto;
}

[dir="rtl"] .toggle-password {
  left: auto;
  right: 0.75rem;
}

[dir="rtl"] .form-control {
  text-align: right;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 1rem;
  }

  .form-row {
    flex-direction: column;
  }

  .col-4,
  .col-6 {
    width: 100%;
    margin-bottom: 1rem;
  }
}
</style>
